module.exports = __webpack_public_path__ + "img/icon3.de38ab57.png";